import { Identifier } from 'react-admin';
import { JobPhasePaidBatchInterface } from '@vatos-pas/common';

/** POST target of the Prod Payables MS "Mark as Paid" action. */
export const PROD_PAY_MARK_AS_PAID_RESOURCE = 'job-phase-paid/batch';

/** Every Prod Payables row id is the job phase id the batch endpoint expects. */
export const buildMarkAsPaidBody = (
  selectedIds: Identifier[],
): JobPhasePaidBatchInterface => ({
  jobPhaseIds: selectedIds.map(String),
});
